import { render, staticRenderFns } from "./Item.vue?vue&type=template&id=f24d3214&scoped=true&lang=pug"
import script from "./Item.vue?vue&type=script&lang=js"
export * from "./Item.vue?vue&type=script&lang=js"
import style0 from "./Item.vue?vue&type=style&index=0&id=f24d3214&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24d3214",
  null
  
)

export default component.exports